
var angular:angular.IAngularStatic =  require('angular');

import {Injectable, Inject}  from 'ng-metadata/core';
import {getAuthenticationMethods} from '../appConfig/appConfigForward';
import {LoginService} from '../security/login/login.service';
import {JwtUtilService} from '../security/jwtUtil.service'
import {SharedSessionStorage} from '../infra/sharedSessionStorage.service';


@Injectable()
export class LoginIframeService{


    private tryAgain : boolean;
    private url : string;
    private urls : Array<string>;
    private _iframeSilentLoginEnabled : boolean;

	constructor(@Inject('$window') private $window: ng.IWindowService,
                private loginService: LoginService,
                private sharedSessionStorage: SharedSessionStorage,
                private jwtUtilService: JwtUtilService,
                @Inject('$location') private $location: ng.ILocationService) {
	    this.tryAgain = false;
	    this.urls = this.getLoginUrls();
	    this.url = this.urls.shift();
        this._iframeSilentLoginEnabled = false;
	    for( let i =0 ; i< window.appConfig.authentication.length ;i++){
            //login and account states perform a login so in order to avoid bugs we don't want silent login to send another login request
            if(this.$location.path() !== '/account' && this.$location.path() !== '/login' &&
                window.appConfig.authentication[i]["silent-login-enabled"]==='true'){
                this._iframeSilentLoginEnabled = true;
                break;
            }
        }
	}

	public setTryAgain(tryAgain){
	    this.tryAgain = tryAgain;
    }

    public getTryAgain(){
	    return this.tryAgain;
    }

	public getUrl(){
	    return this.url;
    }

    public advanceToNextUrl(){
	    if(this.urls.length){
            this.url = this.urls.shift();
            this.sharedSessionStorage.setItem('trySilentLogin', 'true');
             this.tryAgain = true;
             return true;
        }else{
	        this.url = undefined;
	        this.tryAgain = false;
	        return false;
        }
    }

    public getLoginUrls(){
        let authenticationMethodArr =  getAuthenticationMethods();
        let silentLoginUrlsArr : Array<string>=[];
        for(let i = 0 ;i < authenticationMethodArr.length ; i++){
            if ( authenticationMethodArr[i].isSilentLoginSupported()){
                if(window.appConfig.authentication[i]["silent-login-enabled"]==='true'){
                    silentLoginUrlsArr.push(this.loginService.loginUrl(authenticationMethodArr[i].profileName,
                        authenticationMethodArr[i].authenticationSystem,'',true));
                }
            }
        }
        return silentLoginUrlsArr;
    }

    public trySilentLogin(){
        this._iframeSilentLoginEnabled = false;
        //allow bypass of silent login - mainly for automation reasons
        let byPassSilentLogin = this.$window.location.search.indexOf('noSilentLogin=true')>-1;
        if(byPassSilentLogin){
            return false;
        }

        let user = this.jwtUtilService.getDecodedToken().user;
        if( user){
            if( this.jwtUtilService.getDecodedToken().userGroup != 'GUEST'){
                this.sharedSessionStorage.setItem('trySilentLogin', "false");
                return false;
            }
        }

        if( window.location.search.includes('performLogout=true')){
            this.sharedSessionStorage.setItem('trySilentLogin', "false");
            return false;
        }

        if(this.sharedSessionStorage.getItem('trySilentLogin') === "false"){
            return false;
        }else{
            this.sharedSessionStorage.setItem('trySilentLogin', "false");
            this._iframeSilentLoginEnabled = true;
            return true;
        }
    }

    public get iframeSilentLoginEnabled(): boolean {
        return this._iframeSilentLoginEnabled;
    }


}



// WEBPACK FOOTER //
// ./src/main/webapp/components/primoExplore/loginIframe.service.ts